<script>
  export let title;
  export let value;
  export let error;
  export let isHorizontal = false;
  export let description;
  export let tooltip;
  export let disabled;
</script>

<style>
  .field {
    display: flex;
    flex-direction: column;
  }
  .field-label {
    text-align: left;
    flex-grow: 0;
    margin-right: 0;
  }
  .field-label .label {
    display: block;
    white-space: nowrap;
    margin-right: 0.8rem;
  }
  .bp-description {
    padding: 0;
  }
</style>

<div class="field" class:is-horizontal={isHorizontal}>
  <div class="is-flex">
    <div class:field-label={isHorizontal} class="is-small">
      <label class="label">{title}</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <label
            class="checkbox"
            data-tooltip={tooltip ? tooltip : undefined}
            {disabled}>
            <input type="checkbox" bind:checked={value} {disabled} />
          </label>
        </div>
      </div>
    </div>
  </div>
  {#if description}
    <p class="bp-description">{description}</p>
  {/if}
</div>
